import { render, staticRenderFns } from "./ReplicateMenusStartForm.vue?vue&type=template&id=6b8687ef"
import script from "./ReplicateMenusStartForm.vue?vue&type=script&lang=ts"
export * from "./ReplicateMenusStartForm.vue?vue&type=script&lang=ts"
import style0 from "./ReplicateMenusStartForm.vue?vue&type=style&index=0&id=6b8687ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports